import store from '../../store/index'
import i18n from '@/plugins/i18n'
import { showError } from '../Mensaje'

export function getMensajeInternacionalizado(codigo, parametros) 
{
  let mensaje = ''

  // obtengo el idioma seleccionado en el UX
  let idioma = i18n.locale.toUpperCase()

  // obtengo los mensajes del app store de vuex
  let listaMensajes = store.state.app.mensajes || []
  
  // obtengo el mensaje en el idioma seleccionado
  let mensajeInternacionalizado = listaMensajes.find((x) => { if(x.Id == codigo && x.Idioma == idioma) return x })
  if(mensajeInternacionalizado !== undefined)
  {
    mensaje = mensajeInternacionalizado.Mensaje

    // agrego los parámetros al mensaje
    if(parametros !== undefined)
      mensaje = `${mensaje} ${parametros}`
  }
  else
  {
    var errorCode = codigo.CodigoResultado!==undefined?codigo.CodigoResultado:codigo;
    // busco el error en el archivo de recursos (i18n)
    let idError = `ERROR_CODE_${errorCode}`
    mensaje = i18n.messages[i18n.locale][idError]
    
    // si no se encontró el mensaje...
    if(mensaje === undefined)
    {
      // muestro un mensaje genérico
      console.log(`Código de error no encontrado: ${codigo}`)
      mensaje = getMensajeNoEncontrado(idioma)

      // agrego más información al mensaje
      if(parametros !== undefined)
        mensaje = `${mensaje}. DETALLE: ${parametros}`
    }
  }

  return mensaje
}

export function mostrarMensajeInternacionalizado(codigo, parametros) 
{
  let mensaje = getMensajeInternacionalizado(codigo, parametros)

  // muestro el mensaje de error
  showError(mensaje)
}

function getMensajeNoEncontrado(idioma) 
{
  switch(idioma) 
  {
    case "ES":
      return "Se produjo un error inesperado"
    case "EN":
      return "An error has ocurred"
    default:
      return "ERROR"
  }
}